module.exports = __webpack_public_path__ + "assets/manual_travelingAbroad-d80f84b90fbcdc16fab51a4377eed02f.pdf";